export default [
  {
    icon: 'fab fa-facebook-f',
    label: 'Facebook',
    provider: 'facebook'
  },
  {
    icon: 'far fa-calendar-alt',
    label: 'Facebook Calendar',
    provider: 'facebook-calendar'
  },
  {
    icon: 'fab fa-google',
    label: 'Google',
    provider: 'google'
  },
  {
    icon: 'fas fa-map-marker',
    label: 'Google Maps',
    provider: 'google-maps'
  },
  {
    icon: 'fab fa-instagram',
    label: 'Instagram',
    provider: 'instagram'
  },
  {
    icon: 'fab fa-linkedin',
    label: 'Linkedin',
    provider: 'linkedin'
  },
  {
    icon: 'fab fa-soundcloud',
    label: 'SoundCloud',
    provider: 'soundcloud'
  },
  {
    icon: 'fab fa-spotify',
    label: 'Spotify',
    provider: 'spotify'
  },
  {
    icon: 'fab fa-twitter',
    label: 'Twitter',
    provider: 'twitter'
  },
  {
    icon: 'fab fa-youtube',
    label: 'Youtube',
    provider: 'youtube'
  }
]
